// Settings → Morning e-mail «Η μέρα μου» (ideas track, idea 38). The advisor turns it on, picks the time (default
// 07:30 Cyprus time) and the address (default: the e-mail of his AVRASTRO account). The setting syncs to the platform,
// which sends the e-mail on working days. Counts and first names only; the daily sheet is a link into the app.
import { useState } from 'react';
import { saveSetting, morningMailSettings, nextMorningMailDay, isMailAddress, MORNING_MAIL_KEY, type MorningMailSettings } from '@vero/domain';
import { useRuntime } from '../core/runtime.tsx';
import { Field } from '../core/ui.tsx';
import { Icon } from '../core/icons.tsx';
import { accountService } from '../core/account-service.ts';
import { useAccount } from './account.tsx';

type Ev = { target: HTMLInputElement };
export function MorningMailCard() {
  const rt = useRuntime();
  const { t, i18n, view, today } = rt;
  const a = useAccount();
  const cur = morningMailSettings(view);
  const [to, setTo] = useState(cur.to);
  const [busy, setBusy] = useState(false);
  const save = (patch: Partial<MorningMailSettings>) => void rt.run((v, c) => saveSetting(v, MORNING_MAIL_KEY, { ...morningMailSettings(v), userId: cur.userId ?? (a?.userId ?? null), ...patch }, c), 'settings.saved', undefined, { undoable: true });
  const nowTime = new Date().toTimeString().slice(0, 5);
  const next = nextMorningMailDay(cur, today, nowTime);
  const test = async () => {
    const api = accountService()?.api;
    if (!api || !a?.signedIn) { rt.toast(t('morning.need_account'), 'error'); return; }
    setBusy(true);
    try { const r = await api.morningTest(); rt.toast(t('morning.test_sent', { to: r.to }), 'success'); }
    catch (e) { rt.toast(t('morning.test_failed', { code: String((e as Error).message) }), 'error'); }
    finally { setBusy(false); }
  };
  return (
    <section className="card card-pad" style={{ marginTop: 18 }} data-testid="morning-mail">
      <div className="section-title">{t('morning.title')}</div>
      <p className="small muted" style={{ marginTop: 0 }}>{t('morning.intro')}</p>
      <div className="form-grid">
        <label className="check span2"><input type="checkbox" checked={cur.enabled} onChange={(e: Ev) => save({ enabled: e.target.checked })} data-testid="morning-enabled" />{t('morning.enabled')}</label>
        <Field label={t('morning.time')} hint={t('morning.time_hint')}><input className="input" type="time" value={cur.time} onChange={(e: Ev) => { if (/^\d{2}:\d{2}$/.test(e.target.value)) save({ time: e.target.value }); }} data-testid="morning-time" /></Field>
        <Field label={t('morning.to')} hint={t('morning.to_hint', { email: a?.email ?? '—' })}><input className="input" type="email" value={to} placeholder={a?.email ?? ''} onChange={(e: Ev) => setTo(e.target.value)} onBlur={() => { const v = to.trim(); if (!v || isMailAddress(v)) save({ to: v }); else rt.toast(t('morning.to_invalid'), 'error'); }} data-testid="morning-to" /></Field>
        <Field label={t('morning.lang')}><select className="select" value={cur.lang} onChange={(e: { target: HTMLSelectElement }) => save({ lang: e.target.value === 'en' ? 'en' : 'el' })}><option value="el">Ελληνικά</option><option value="en">English</option></select></Field>
        <label className="check"><input type="checkbox" checked={cur.skipHolidays} onChange={(e: Ev) => save({ skipHolidays: e.target.checked })} />{t('morning.skip_holidays')}</label>
      </div>
      <p className="small" style={{ marginBottom: 6 }}>{cur.enabled ? (next ? t('morning.next', { date: i18n.date(next, 'long'), time: cur.time }) : t('morning.no_next')) : t('morning.off')}</p>
      <p className="tiny muted">{t('morning.privacy')}</p>
      {!a?.signedIn && <p className="tiny muted">{t('morning.need_account')}</p>}
      <button className="btn btn-sm" disabled={busy || !a?.signedIn} onClick={() => void test()} data-testid="morning-test"><Icon name="mail" />{t('morning.test')}</button>
    </section>
  );
}
